import {
  SidePanelTabName,
  useFxWorkspaceContext,
} from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { VerticalTab } from '@trimble/ui-components/solidjs';
import { Accessor, createMemo } from 'solid-js';
import { WorkspacesTab } from './WorkspacesTab';

export function createWorkspacesSidePanelTab(): VerticalTab<SidePanelTabName> {
  return {
    name: SidePanelTabName.Workspaces,
    tooltip: {
      text: t('mobileMapping.fxWorkspace.title'),
      position: 'right' as const,
    },
    icon: 'tc-icon-folder',
    content: () => <WorkspacesTab />,
  };
}

export function useWorkspacesSidePanelTab(): Accessor<
  readonly VerticalTab<SidePanelTabName>[]
> {
  const fxWorkspace = useFxWorkspaceContext();

  const workspacesSidePanelTab = createMemo(() =>
    fxWorkspace.isEnabled() ? [createWorkspacesSidePanelTab()] : []
  );

  return workspacesSidePanelTab;
}
